import React, { useCallback } from 'react';
import {
    required,Create,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices, Button,
    Edit, SimpleForm, TextInput,ReferenceInput, SelectInput,FormDataConsumer,
    DateInput, BooleanInput, NumberInput,FileInput, FileField,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { useForm } from 'react-final-form';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import * as apiClient from "../../common/apiClient";
import CreateToolbar from "../../CreateToolbar";
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from "../../formStyles";
import moment from "moment";
import {Addressfields} from "./Addressfields";
 
const PostCreateToolbar = props => (
       
    <Toolbar {...props}>
        <SaveButton submitOnEnter={true}  onSave={props.onSave} />
        <Button
        variant="contained" color="primary"
        label="Back" size="medium"
        startIcon={<CancelIcon />}
        style={{marginLeft:"30px"}}
        onClick={props.onCancel}
        />
    </Toolbar>
);
const EventCreate = props => {
    const classes = useStyles({});
     
    const handleSubmit = async (formdata) => {
         console.log(formdata);
         let user = localStorage.getItem("userId");
         if (user) {
         user = parseInt(user);
         }
        

          formdata.orderId=parseInt(props.id);
          formdata.createdBy=  user;
          formdata.createdDate= moment().toISOString();
          formdata.modifyBy= user;
          formdata.modifyDate= moment().toISOString();
           
        apiClient.addEntiyRecord("/lead-order-events", formdata).then(res => {
            console.log(res);
            props.onClose();
        }).catch(err => {
            console.log(err);
        });
        
        
    }
    return (
        <Create {...props}>
            <SimpleForm onSubmit={handleSubmit} 
                toolbar={<PostCreateToolbar onSave={handleSubmit} onCancel={props.onCancel}   />} variant="outlined" >

                          
           
           
            <TextInput source="remarks" label="Remarks" fullWidth={true}    validate={[required()]} multiline/>  

            </SimpleForm>
        </Create>
    );
}
export default EventCreate;